import React, { useMemo } from "react";
// import { Tooltip, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { Tooltip, Typography } from "@material-ui/core";

const EllipsisWithTooltip = ({
  text = "",
  maxWidth = "100px",
  variant = "body2",
  color = "inherit",
  placement = "top",
  ...props
}) => {
  const textRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current) {
        const { scrollWidth, clientWidth } = textRef.current;
        setShowTooltip(scrollWidth > clientWidth);
      }
    };
    checkOverflow();
  }, [text, maxWidth]);

  return (
    <Tooltip
      title={text}
      disableHoverListener={!showTooltip}
      arrow
      placement={placement}
    >
      <Typography
        ref={textRef}
        variant={variant}
        color={color}
        noWrap
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth,
        }}
        {...props}
      >
        {text}
      </Typography>
    </Tooltip>
  );
};
EllipsisWithTooltip.propTypes = {
  text: PropTypes.string,
  maxWidth: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  placement: PropTypes.string,
};

export default EllipsisWithTooltip;
